import BaseService from "./BaseService";
import AppUtils from "../utils/BaseUtils/AppUtils";

class ApplicantServices extends BaseService {
  fetchRolesAndSkills(
    payload,
    successAction,
    loaderType,
    errorType,
    showSuccessMessage,
    successCondition,
    getErrorMessage
  ) {
    return this.makePostRequest(
      AppUtils.urls.applicant.FETCH_ROLES_AND_SKILLS,
      payload,
      successAction,
      loaderType,
      errorType,
      false,
      successCondition,
      getErrorMessage
    );
  }
  fetchIndustries(
    payload,
    successAction,
    loaderType,
    errorType,
    showSuccessMessage,
    successCondition,
    getErrorMessage
  ) {
    return this.makePostRequest(
      AppUtils.urls.applicant.FETCH_INDUSTRIES,
      payload,
      successAction,
      loaderType,
      errorType,
      false,
      successCondition,
      getErrorMessage
    );
  }
  addEmployment(
    payload,
    successAction,
    loaderType,
    errorType,
    showSuccessMessage,
    successCondition,
    getErrorMessage
  ) {
    return this.makePostRequest(
      AppUtils.urls.applicant.ADD_EMPLOYMENT,
      payload,
      successAction,
      loaderType,
      errorType,
      false,
      successCondition,
      getErrorMessage
    );
  }
  addProject(
    payload,
    successAction,
    loaderType,
    errorType,
    showSuccessMessage,
    successCondition,
    getErrorMessage
  ) {
    return this.makePostRequest(
      AppUtils.urls.applicant.ADD_PROJECT,
      payload,
      successAction,
      loaderType,
      errorType,
      false,
      successCondition,
      getErrorMessage
    );
  }
  addEducation(
    payload,
    successAction,
    loaderType,
    errorType,
    showSuccessMessage,
    successCondition,
    getErrorMessage
  ) {
    return this.makePostRequest(
      AppUtils.urls.applicant.ADD_EDUCATION,
      payload,
      successAction,
      loaderType,
      errorType,
      false,
      successCondition,
      getErrorMessage
    );
  }

  editEmployment(
    payload,
    successAction,
    loaderType,
    errorType,
    showSuccessMessage,
    successCondition,
    getErrorMessage
  ) {
    return this.makePostRequest(
      AppUtils.urls.applicant.EDIT_EMPLOYMENT,
      payload,
      successAction,
      loaderType,
      errorType,
      false,
      successCondition,
      getErrorMessage
    );
  }
  editProject(
    payload,
    successAction,
    loaderType,
    errorType,
    showSuccessMessage,
    successCondition,
    getErrorMessage
  ) {
    return this.makePostRequest(
      AppUtils.urls.applicant.EDIT_PROJECT,
      payload,
      successAction,
      loaderType,
      errorType,
      false,
      successCondition,
      getErrorMessage
    );
  }
  fetchEmploymentHistory(
    payload,
    successAction,
    loaderType,
    errorType,
    showSuccessMessage,
    successCondition,
    getErrorMessage
  ) {
    return this.makePostRequest(
      AppUtils.urls.applicant.FETCH_EMPLOYMENT_HISTORY,
      payload,
      successAction,
      loaderType,
      errorType,
      false,
      successCondition,
      getErrorMessage
    );
  }
  deleteEmployment(
    payload,
    successAction,
    loaderType,
    errorType,
    showSuccessMessage,
    successCondition,
    getErrorMessage
  ) {
    return this.makePostRequest(
      AppUtils.urls.applicant.DELETE_EMPLOYMENT,
      payload,
      successAction,
      loaderType,
      errorType,
      false,
      successCondition,
      getErrorMessage
    );
  }
  deleteProject(
    payload,
    successAction,
    loaderType,
    errorType,
    showSuccessMessage,
    successCondition,
    getErrorMessage
  ) {
    return this.makePostRequest(
      AppUtils.urls.applicant.DELETE_PROJECT,
      payload,
      successAction,
      loaderType,
      errorType,
      false,
      successCondition,
      getErrorMessage
    );
  }
  editEducation(
    payload,
    successAction,
    loaderType,
    errorType,
    showSuccessMessage,
    successCondition,
    getErrorMessage
  ) {
    return this.makePostRequest(
      AppUtils.urls.applicant.EDIT_EDUCATION,
      payload,
      successAction,
      loaderType,
      errorType,
      false,
      successCondition,
      getErrorMessage
    );
  }
  fetchEducationHistory(
    payload,
    successAction,
    loaderType,
    errorType,
    showSuccessMessage,
    successCondition,
    getErrorMessage
  ) {
    return this.makePostRequest(
      AppUtils.urls.applicant.FETCH_EDUCATION_HISTORY,
      payload,
      successAction,
      loaderType,
      errorType,
      false,
      successCondition,
      getErrorMessage
    );
  }
  fetchProjectHistory(
    payload,
    successAction,
    loaderType,
    errorType,
    showSuccessMessage,
    successCondition,
    getErrorMessage
  ) {
    return this.makePostRequest(
      AppUtils.urls.applicant.FETCH_PROJECT_HISTORY,
      payload,
      successAction,
      loaderType,
      errorType,
      false,
      successCondition,
      getErrorMessage
    );
  }
  editPortfolio(
    payload,
    successAction,
    loaderType,
    errorType,
    showSuccessMessage,
    successCondition,
    getErrorMessage
  ) {
    return this.makePostRequest(
      AppUtils.urls.applicant.EDIT_PORTFOLIO,
      payload,
      successAction,
      loaderType,
      errorType,
      false,
      successCondition,
      getErrorMessage
    );
  }
  fetchPortfolio(
    payload,
    successAction,
    loaderType,
    errorType,
    showSuccessMessage,
    successCondition,
    getErrorMessage
  ) {
    return this.makePostRequest(
      AppUtils.urls.applicant.FETCH_PORTFOLIO,
      payload,
      successAction,
      loaderType,
      errorType,
      false,
      successCondition,
      getErrorMessage
    );
  }
  fetchPortfolioLinks(
    payload,
    successAction,
    loaderType,
    errorType,
    showSuccessMessage,
    successCondition,
    getErrorMessage
  ) {
    return this.makePostRequest(
      AppUtils.urls.applicant.FETCH_PORTFOLIO_LINKS,
      payload,
      successAction,
      loaderType,
      errorType,
      false,
      successCondition,
      getErrorMessage
    );
  }
  fetchAllJobs(
    payload,
    successAction,
    loaderType,
    errorType,
    showSuccessMessage,
    successCondition,
    getErrorMessage
  ) {
    return this.makePostRequest(
      AppUtils.urls.applicant.FETCH_ALL_JOBS,
      payload,
      successAction,
      loaderType,
      errorType,
      false,
      successCondition,
      getErrorMessage
    );
  }
  fetchAppliedJobs(
    payload,
    successAction,
    loaderType,
    errorType,
    showSuccessMessage,
    successCondition,
    getErrorMessage
  ) {
    return this.makePostRequest(
      AppUtils.urls.applicant.FETCH_APPLIED_JOBS,
      payload,
      successAction,
      loaderType,
      errorType,
      false,
      successCondition,
      getErrorMessage
    );
  }
  acceptInterview(
    payload,
    successAction,
    loaderType,
    errorType,
    showSuccessMessage,
    successCondition,
    getErrorMessage
  ) {
    return this.makePostRequest(
      AppUtils.urls.applicant.ACCEPT_INTERVIEW,
      payload,
      successAction,
      loaderType,
      errorType,
      false,
      successCondition,
      getErrorMessage
    );
  }
  fetchApplicantInterviews(
    payload,
    successAction,
    loaderType,
    errorType,
    showSuccessMessage,
    successCondition,
    getErrorMessage
  ) {
    return this.makePostRequest(
      AppUtils.urls.applicant.FETCH_APPLICANT_INTERVIEWS,
      payload,
      successAction,
      loaderType,
      errorType,
      false,
      successCondition,
      getErrorMessage
    );
  }
  applyJob(
    payload,
    successAction,
    loaderType,
    errorType,
    showSuccessMessage,
    successCondition,
    getErrorMessage
  ) {
    return this.makePostRequest(
      AppUtils.urls.applicant.APPLY_JOB,
      payload,
      successAction,
      loaderType,
      errorType,
      false,
      successCondition,
      getErrorMessage
    );
  }
  declineInterview(
    payload,
    successAction,
    loaderType,
    errorType,
    showSuccessMessage,
    successCondition,
    getErrorMessage
  ) {
    return this.makePostRequest(
      AppUtils.urls.applicant.DECLINE_INTERVIEW,
      payload,
      successAction,
      loaderType,
      errorType,
      false,
      successCondition,
      getErrorMessage
    );
  }
  rescheduleInterview(
    payload,
    successAction,
    loaderType,
    errorType,
    showSuccessMessage,
    successCondition,
    getErrorMessage
  ) {
    return this.makePostRequest(
      AppUtils.urls.applicant.RESCHEDULE_INTERVIEW,
      payload,
      successAction,
      loaderType,
      errorType,
      false,
      successCondition,
      getErrorMessage
    );
  }
  fetchJobInterviews(
    payload,
    successAction,
    loaderType,
    errorType,
    showSuccessMessage,
    successCondition,
    getErrorMessage
  ) {
    return this.makePostRequest(
      AppUtils.urls.applicant.FETCH_JOB_INTERVIEWS,
      payload,
      successAction,
      loaderType,
      errorType,
      false,
      successCondition,
      getErrorMessage
    );
  }
  fetchApplicantOffers(
    payload,
    successAction,
    loaderType,
    errorType,
    showSuccessMessage,
    successCondition,
    getErrorMessage
  ) {
    return this.makePostRequest(
      AppUtils.urls.applicant.VIEW_OFFER,
      payload,
      successAction,
      loaderType,
      errorType,
      false,
      successCondition,
      getErrorMessage
    );
  }
  fetchAllApplicants(
    payload,
    successAction,
    loaderType,
    errorType,
    showSuccessMessage,
    successCondition,
    getErrorMessage
  ) {
    return this.makePostRequest(
      AppUtils.urls.applicant.FETCH_ALL_APPLICANTS,
      payload,
      successAction,
      loaderType,
      errorType,
      false,
      successCondition,
      getErrorMessage
    );
  }
}

export default ApplicantServices;
